import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.75, y: 0.75, width: 16.5, height: 16.5, rx: 6, ry: 6, stroke: "currentColor", strokeWidth: 1 }));
const ForwardRef = forwardRef(SvgCheckbox);
export { ForwardRef as ReactComponent };
